import { RefObject, useEffect, useState } from 'react';

/**
 * Whether a one-line, ellipsized element is actually cut off right now - so a
 * tooltip with the whole text can exist only while it is needed.
 *
 * Re-measured on resize. Measured once on mount too, which is what counts in
 * a tab the browser is not painting: ResizeObserver never fires there.
 */
export const useIsTruncated = (
  ref: RefObject<HTMLElement>,
  /** Re-measure when this changes, e.g. the text itself. */
  watch?: unknown
) => {
  const [truncated, setTruncated] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // 1px of slack: sub-pixel widths report a phantom overflow.
    const check = () => setTruncated(el.scrollWidth - el.clientWidth > 1);
    check();
    const observer = new ResizeObserver(check);
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, watch]);

  return truncated;
};
